//Local
//export const URL_BASE = "http://localhost:8081/pridel-api"; //specify base url of all requests
//export const URL_BASE_DOC = "http://localhost:80"; //specify base url of all requests
// export const URL_BASE = "https://api-pridel-test.binarynumbers.io"; //specify base url of all requests
// export const URL_BASE_DOC = "https://prideluploads.binarynumbers.io"; //specify base url of all requests
//Live
//164.52.196.219

// export const URL_BASE = "http://164.52.196.219/pridelApi-V2"; //specify base url of all requests
// export const URL_BASE_DOC = "http://164.52.196.219"; //specify base url of all requests

// This is Local Section Start
// export const URL_BASE = "http://164.52.198.182/pridaldev-phase2/pridelApi-V2-test"; //specify base url of all requests
// export const URL_BASE_DOC = "http://164.52.198.182/pridaldev-phase2"; //specify base url of all requests
// This is Local Section End
// This is Live Section Start
export const URL_BASE = "https://api-pridel.pridel.com"; //specify base url of all requests
export const URL_NODE_BASE =
  window.location.hostname === "localhost"
    ? "https://apiv2.pridel.com/api/"
    : "https://apiv2.pridel.com/api/"; //specify base url of all requests http://localhost:8005/api/
// export const URL_NODE_BASE = "https://apiv2.pridel.com"; //specify base url of all requests
// export const URL_BASE_DOC = "https://uploadsp.binarynumbers.io"; //specify base url of all requests

// This is Live Section End
export const URL_BASE_DOC =
  "https://pridel-document.s3.ap-south-1.amazonaws.com/upload_pic"; //specify base url of all requests

export const APP_NAME = "";
export const APP_IMG = "/assets/pridel.png";
// export const Username =;

//colors
export const WHITE = "#FFFFFF";
export const WHITE_SHADE = "#F1F1F1";
export const BLACK = "#000000";
export const PRIMARY_COLOR = "#607d8d";
export const DARK_GRAY = "#5F5F5F";
export const FOOTER_COLOR = "#EAECEF";
export const TRANSPARENT = "rgba(0,0,0,0.1)";
//regex
export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;



// WEBPACK FOOTER //
// ./src/helper/constant.js